import React from "react";
import { RhdHeaderCellWrapper } from "./Grid.styles";

export const RhDHeaderCell: React.FC = () => (
  <RhdHeaderCellWrapper>RhD/Fetal Antigen</RhdHeaderCellWrapper>
);
